/* PLP card video — viewport-gated lazy autoplay for custom-card-product-video.
   Loaded ONCE per page from theme.liquid (not per card), so a full grid of video
   cards costs one small script, not one per product. A card video downloads and
   plays only when it scrolls into view, and pauses when it leaves. Injects its
   own CSS. Re-scans cards added by filtering / See More. */
(function () {
  var css = '.plp-first-media-video{display:block;width:100%;line-height:0}'
    + '.plp-first-media-video video.plp-card-video{display:block;width:100%;height:auto;object-fit:cover;background:#f4f4f4}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function run() {
    if (!('IntersectionObserver' in window)) return;
    function load(v) {
      if (v.dataset.saiVidLoaded) return;
      v.dataset.saiVidLoaded = '1';
      v.querySelectorAll('source[data-src]').forEach(function (s) {
        if (!s.getAttribute('src')) s.setAttribute('src', s.getAttribute('data-src'));
      });
      v.load();
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { load(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (v.pause) { v.pause(); }
      });
    }, { rootMargin: '150px 0px', threshold: 0.25 });

    function obs(root) {
      if (root && root.querySelectorAll) root.querySelectorAll('video.plp-card-video').forEach(function (v) { io.observe(v); });
    }
    obs(document);
    var grid = document.getElementById('product-grid') || document.querySelector('.lotto-plp-grid') || document.body;
    if (grid && 'MutationObserver' in window) {
      new MutationObserver(function (ms) {
        ms.forEach(function (m) { (m.addedNodes || []).forEach(function (n) { if (n.nodeType === 1) obs(n); }); });
      }).observe(grid, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
